import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import UserLink from '../../../../User/Link/UserLink';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiData } from '@wix/da-bi/pkg/events';
import s from './Subjects.scss';
export const Subjects = ({ className, subjectTags, locationTag })=>{
    const { t } = useTranslation();
    if ((!subjectTags || !subjectTags.length) && !locationTag) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, subjectTags && subjectTags.map((subject)=>/*#__PURE__*/ React.createElement("span", {
            key: subject.name,
            className: s['subject']
        }, /*#__PURE__*/ React.createElement("span", {
            className: s['subject-title']
        }, t(`deviation.subject.${subject.type}`)), "  ", subject.user && /*#__PURE__*/ React.createElement(UserLink, {
            user: subject.user
        }), !subject.user && /*#__PURE__*/ React.createElement(BiLink, {
            className: s['subject-name'],
            href: subject.url,
            biData: BiData({
                evid: 392,
                subject_name: subject.name,
                subject_type: subject.type
            })
        }, subject.name))), locationTag && /*#__PURE__*/ React.createElement("span", {
        className: s['subject']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['subject-title']
    }, t('deviation.subject.location')), "  ", /*#__PURE__*/ React.createElement(BiLink, {
        className: s['subject-name'],
        href: locationTag.url,
        biData: BiData({
            evid: 393,
            location_name: locationTag.name
        })
    }, locationTag.name)));
};
Subjects.displayName = 'Subjects';
export default Subjects;

//# sourceMappingURL=Subjects.js.map